import React from 'react'
import { useTranslation } from 'react-i18next'

import Modal from 'common/components/feedback/Modal'
import Button from 'common/components/general/Button'

interface Props {
  visible: boolean

  loading: boolean
  headerTitle: string
  content?: string
  handleOk: () => void
  handleCancel: () => void
}

const ConfirmFinishSignup: React.FC<Props> = ({ visible, handleOk, handleCancel, loading, headerTitle, content }) => {
  const { t: translate } = useTranslation('ichra-decision-tool')
  return (
    <Modal
      visible={visible}
      title={headerTitle}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          {translate('cancel')}
        </Button>,
        <Button key="pay" type="primary" onClick={handleOk} loading={loading}>
          {translate('continue')}
        </Button>,
      ]}
    >
      <div>
        <p>{content}</p>
      </div>
    </Modal>
  )
}

export default ConfirmFinishSignup
